import { useState, useCallback, useRef } from "react"
import { useMutation } from "src/hooks/useMutation"
import * as cpApi from "../api/channelPartnersApi"

// ── Channel partners list ─────────────────────────────────────────────────────
export function useChannelPartners() {
  const [data, setData] = useState(null) // { channel_partners, meta }
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortRef = useRef(null)

  const fetch = useCallback(async (filters = {}) => {
    if (abortRef.current) abortRef.current.abort()
    abortRef.current = new AbortController()
    setLoading(true)
    setError(null)
    try {
      setData(await cpApi.fetchChannelPartners(filters))
    } catch (err) {
      if (err.name !== "AbortError") setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch }
}

export const useCreateChannelPartner = () => useMutation(cpApi.createChannelPartner)
export const useUpdateChannelPartner = () => useMutation((id, p) => cpApi.updateChannelPartner(id, p))
export const useDeactivateChannelPartner = () => useMutation(cpApi.deactivateChannelPartner)

// ── Performance ────────────────────────────────────────────────────────────────
export function useChannelPartnerPerformance() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetch = useCallback(async (filters = {}) => {
    setLoading(true)
    try {
      setData(await cpApi.fetchChannelPartnerPerformance(filters))
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, fetch }
}
